import buildPropertyRatesKey from 'lib/offer/buildPropertyRatesKey'
import { API_CALL } from './actionConstants'
import { AppAction } from './ActionTypes'
import { FETCH_PROPERTY_RATES_LIST } from './apiActionConstants'
import { getPropertyRatesList } from 'api/accommodation'

interface PropertyRatesParams {
  checkIn: string;
  checkOut: string;
  occupancies: Array<App.Occupants> | App.Occupants;
  dynamicAvailability: boolean;
}

// NOTE: Not finished, not use
// export function fetchPropertyRates(propertyId: string, params: PropertyRatesParams): AppAction {
//   return (dispatch, getState) => {
//     const state = getState()

//     const key = buildPropertyRatesKey(propertyId, params)

//     dispatch({
//       type: API_CALL,
//       api: FETCH_PROPERTY_RATES,
//       request: () => getPropertyRates(propertyId, {
//         checkIn: params.checkIn,
//         checkOut: params.checkOut,
//         currency: state.geo.currentCurrency,
//         regionCode: state.geo.currentRegionCode,
//         occupancies: Array.isArray(params.occupancies) ? params.occupancies : [params.occupancies],
//       }),
//       key,
//     })
//   }
// }

export function fetchPropertyRatesList(propertyId: string, params: PropertyRatesParams): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const key = buildPropertyRatesKey(propertyId, params)

    if (state.offer.propertyRatesLists[key]) {
      // already processed it
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_PROPERTY_RATES_LIST,
      request: () => getPropertyRatesList(propertyId, {
        checkIn: params.checkIn,
        checkOut: params.checkOut,
        currency: state.geo.currentCurrency,
        regionCode: state.geo.currentRegionCode,
        occupancies: Array.isArray(params.occupancies) ? params.occupancies : [params.occupancies],
        dynamicAvailability: params.dynamicAvailability,
      }),
      key,
    })
  }
}
